"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PARTNER_LANDING_PAGE = exports.DEFAULT_PARTNER_SUPPORT_EMAIL = void 0;
/**
 * Fallback values used when a partner has not set its own per-partner value on partner_details.
 * The backend resolves these in getPartnerInfo; the frontend uses the same constants as a
 * while-loading fallback so both sides stay in sync (single source of truth).
 */
exports.DEFAULT_PARTNER_SUPPORT_EMAIL = 'support@aven.com';
exports.DEFAULT_PARTNER_LANDING_PAGE = 'dashboard.avenfoundry.com';
